import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import { ResyncConfTablesMaster } from "./ResyncConfTablesMaster";
//import { ResyncConfTables } from "./ResyncConfTablesView/ResyncConfTables";

const ResyncConfTablesRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url },
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <ResyncConfTablesMaster />} />
  </Switch>
);

export const ResyncConfTablesManagement = withRouter(ResyncConfTablesRoutes);
